import React from 'react';
import { useFormikContext } from 'formik';

interface IconButton {
  children: React.ReactNode;
  isDisabled?: boolean;
  onClick?: () => void;
  size?: 24;
  type?: 'button' | 'submit';
}

const IconButton = ({
  children,
  isDisabled,
  onClick,
  size,
  type = 'button',
}: IconButton) => {
  const { isSubmitting } = useFormikContext() || {};
  const isHtmlDisabled = isDisabled || (isSubmitting && type == 'submit');

  return (
    <button
      className="whatcrm-widget-icon-btn"
      disabled={isHtmlDisabled}
      onClick={onClick}
      style={{ height: size, width: size }}
      type={type}
    >
      {children}
    </button>
  );
};

export default IconButton;
